import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, CheckCircle2, ShieldAlert } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el regalo?',
  a: 'Inmediatamente después del pago, recibirás un link de descarga en tu email. Es instantáneo, no importa si son las 3 AM.'
}, {
  q: 'Mi papá no es tecnológico, ¿le servirá?',
  a: '¡Claro! El formato está optimizado para verse fácil en el celular o incluso para que lo imprimas y se lo entregues en una carpeta. No requiere instalar nada raro.'
}, {
  q: '¿Sirve para cualquier tipo de parrilla?',
  a: 'Sí, el método funciona igual para parrillas a carbón, leña e incluso a gas (aunque damos tips para recuperar ese sabor ahumado en gas).'
}, {
  q: '¿En qué moneda está el precio?',
  a: 'Pesos chilenos (CLP). El precio que ves es el que pagas, sin sorpresas de impuestos ni conversiones raras.'
}];
export function FAQGuaranteeSection() {
  return <div className="bg-bbq-dark py-12 md:py-24 px-4" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        {/* FAQ Section */}
        <section className="mb-24" data-id="element-27">
          <div className="text-center mb-12" data-id="element-28">
            <HelpCircle className="mx-auto text-bbq-gold mb-4" size={48} data-id="element-29" />
            <h2 className="text-3xl md:text-4xl font-display font-bold text-white uppercase tracking-wide" data-id="element-30">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-6" data-id="element-31">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-bbq-surface p-6 rounded-xl border border-white/5" data-id="element-32">
                <h3 className="text-xl font-bold text-white mb-3 flex items-start gap-3" data-id="element-33">
                  <span className="text-bbq-ember mt-1" data-id="element-34">❓</span>
                  {faq.q}
                </h3>
                <p className="text-gray-400 flex items-start gap-3 pl-8" data-id="element-35">
                  <CheckCircle2 className="text-green-500 shrink-0 mt-1" size={20} data-id="element-36" />
                  {faq.a}
                </p>
              </motion.div>)}
          </div>
        </section>

        {/* Guarantee Section */}
        <motion.section initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-bbq-surface to-bbq-dark p-8 md:p-12 rounded-2xl border-2 border-bbq-gold/30 text-center relative overflow-hidden" data-id="element-37">
          <div className="absolute -right-10 -top-10 text-bbq-gold/10" data-id="element-38">
            <ShieldAlert size={200} data-id="element-39" />
          </div>
          <ShieldAlert className="mx-auto text-bbq-gold mb-6 relative z-10" size={64} data-id="element-40" />
          <h2 className="text-3xl font-display font-bold text-white uppercase tracking-wide mb-6 relative z-10" data-id="element-41">
            Garantía de "Aplauso Familiar"
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed relative z-10" data-id="element-42">
            Si tu papá aplica estas técnicas en su próximo asado y la familia no
            se pone de pie para aplaudirlo por la calidad de la carne,{' '}
            <strong className="text-white" data-id="element-43">
              te devolvemos el 100% de tu dinero.
            </strong>{' '}
            Tienes 7 días para probarlo. Sin preguntas. El riesgo es todo
            nuestro.
          </p>
        </motion.section>
      </div>
    </div>;
}